import { useEffect, useState } from "react";
import api from "../lib/api";
import DataTable from "../components/DataTable";
import PageHeader from "../components/PageHeader";
import { Badge, statusVariant } from "../components/Badge";
import { Plus } from "lucide-react";
import { toast } from "sonner";
import { fmtBDT } from "../lib/format";
import NumberInput from "../../components/ui/NumberInput";

export default function Commission() {
  const [rows, setRows] = useState([]);
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ agent_name: "", amount: "", period: "February 2026", status: "paid" });

  const load = async () => {
    setLoading(true);
    const [{ data: cm }, { data: ag }] = await Promise.all([api.get("/commissions"), api.get("/agents")]);
    setRows(cm);
    setAgents(ag);
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    await api.post("/commissions", { ...form, amount: parseFloat(form.amount) });
    toast.success("Commission added");
    setOpen(false);
    setForm({ agent_name: "", amount: "", period: "February 2026", status: "paid" });
    load();
  };

  return (
    <div data-testid="commission-page">
      <PageHeader
        title="Commission"
        subtitle="Agent commissions by period"
        actions={(
          <button onClick={() => setOpen(true)} className="h-9 px-3 bg-emerald-500 hover:bg-emerald-600 text-white rounded-sm text-sm font-semibold inline-flex items-center gap-1.5" data-testid="commission-add-btn">
            <Plus size={14} /> New Commission
          </button>
        )}
      />
      {open && (
        <form onSubmit={submit} className="bg-white border border-gray-200 rounded-sm p-5 mb-6 grid grid-cols-1 md:grid-cols-4 gap-3 fade-in-up" data-testid="commission-form">
          <select required value={form.agent_name} onChange={(e) => setForm({ ...form, agent_name: e.target.value })} className="h-9 px-3 border border-gray-200 rounded-sm text-sm">
            <option value="">Select agent</option>
            {agents.map((a) => <option key={a.id} value={a.name}>{a.name}</option>)}
          </select>
          <NumberInput required placeholder="Amount" value={form.amount} onChange={(raw) => setForm({ ...form, amount: raw })} asString className="h-9 px-3 border border-gray-200 rounded-sm text-sm tabular" />
          <input required placeholder="Period" value={form.period} onChange={(e) => setForm({ ...form, period: e.target.value })} className="h-9 px-3 border border-gray-200 rounded-sm text-sm" />
          <select value={form.status} onChange={(e) => setForm({ ...form, status: e.target.value })} className="h-9 px-3 border border-gray-200 rounded-sm text-sm">
            <option value="paid">Paid</option>
            <option value="pending">Pending</option>
          </select>
          <div className="md:col-span-4 flex justify-end gap-2">
            <button type="button" onClick={() => setOpen(false)} className="h-9 px-4 border border-gray-200 rounded-sm text-sm">Cancel</button>
            <button type="submit" className="h-9 px-4 bg-emerald-500 hover:bg-emerald-600 text-white rounded-sm text-sm font-semibold" data-testid="commission-submit">Save</button>
          </div>
        </form>
      )}
      <DataTable
        testId="commission-table"
        loading={loading}
        rows={rows}
        columns={[
          { key: "agent_name", label: "Agent" },
          { key: "amount", label: "Amount", align: "right", render: (r) => fmtBDT(r.amount) },
          { key: "period", label: "Period" },
          { key: "status", label: "Status", render: (r) => <Badge variant={statusVariant(r.status)}>{r.status}</Badge> },
          { key: "created_at", label: "Date", render: (r) => new Date(r.created_at).toLocaleString("en-GB") },
        ]}
      />
    </div>
  );
}
